<div [id]="id" class="status-filters">
    <div #filterByStatus class="overlay-content">
        <p-button
            [id]="id + '-select-status-btn'"
            class="select-status-btn"
            icon="fa-regular fa-chevron-down"
            iconPos="right"
            [label]="selectedStatusTextValue.text | translate"
            [styleClass]="
                selectedStatusTextValue.value !== statusesToDisplay[0].value
                    ? 'selected-status-button'
                    : 'selected-default-status-btn'
            "
            (click)="statusesPanel.toggle($event)"></p-button>

        <p-overlayPanel
            #statusesPanel
            [appendTo]="filterByStatus"
            [ariaLabel]="'groups.status.overlay.ariaLabel' | translate">
            <ng-template pTemplate>
                <div pFocusTrap>
                    @if (additionalFilters) {
                        <div class="additional-filters-container">
                            @for (additionalFilter of additionalFilters; track additionalFilter) {
                                <div id="include-additional-filter-checkbox-container">
                                    <p-checkbox
                                        [inputId]="'additional-filter-' + additionalFilter.key"
                                        [binary]="true"
                                        [label]="additionalFilter.label | translate"
                                        [(ngModel)]="additionalFilter.isSelected"
                                        (click)="$event.stopPropagation()"
                                        (ngModelChange)="
                                            additionalFilterValueChange.emit(additionalFilter)
                                        "></p-checkbox>
                                </div>
                            }
                        </div>

                        <p-divider> </p-divider>
                    }
                    @for (item of statusesToDisplay; track item) {
                        <div class="filter-selection" (click)="statusesPanel.hide(); onStatusSelect(item.value)">
                            <p-button
                                [id]="'other-status-btn-' + item.text"
                                class="status-button"
                                [ngClass]="{ 'selected-filter': item.value === selectedStatus }">
                                <i
                                    [class]="
                                        item.value === selectedStatus
                                            ? 'fa-solid fa-circle fa-2xs'
                                            : 'fa-solid fa-circle-dot fa-2xs'
                                    "></i>
                                <span>{{ item.text | translate }} </span>
                            </p-button>
                        </div>
                    }
                </div>
            </ng-template>
        </p-overlayPanel>
    </div>
</div>
